import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { UserDTO } from '../types/userDTO'

export const USER_WORKSPACE_FRAGMENT: TypedDocumentNode<UserDTO> = gql`
  fragment UserWorkspaceFragment on User {
    userWorkspaces {
      active
      id
      name
      role
    }
  }
`
